import React from 'react';

import {Link} from 'react-router';

import {useAccountSettingsState} from 'app/settings/api';
import {useUpgradeModal} from 'app/toasts/hooks';
import {KB_NEW_KB} from 'app/urls';

interface Props {
  children?: React.ReactNode;
  className?: string;
}

export function CreateKBButton({children, className}: Props) {
  const {showUpgradeModal} = useUpgradeModal();
  const {is_peruser} = useAccountSettingsState().data!;

  const ensureCanCreateKB = (e: React.MouseEvent<HTMLElement>) => {
    if (!is_peruser) {
      e.preventDefault();
      showUpgradeModal((UPGRADE_MODALS) => UPGRADE_MODALS.CREATE_KB);
    }
  };

  return (
    <Link onClick={ensureCanCreateKB} className={className} to={KB_NEW_KB}>
      {children}
    </Link>
  );
}
